import { memo, useCallback } from 'react';
import { BottomSheet, useFocusEffect } from '@bonanza-social/navigation';
import { Box } from '@bonanza-social/moonlight';
import { useSelector } from '@bonanza-social/toolkit/state';
import {
  selectPrizeWallState,
  selectPrizeWallDataState,
} from '../../state/prizeWall/prizeWall.slice';
import { PrizeWallProps } from './PrizeWall.types';
import PrizeWallOpenInfo from '../PrizeWallOpenInfo/PrizeWallOpenInfo';
import PrizeWallWinnersFeed from '../PrizeWallWinnersFeed/PrizeWallWinnersFeed';
import PrizeWallPrizes from '../PrizeWallPrizes/PrizeWallPrizes';
import PrizeWallSkeleton from './PrizeWallSkeleton/PrizeWallSkeleton';

function PrizeWall({
  onCheckWinnersPress,
  onInsufficientBalancePress,
  ...rest
}: PrizeWallProps) {
  const state = useSelector(selectPrizeWallState);
  const dataState = useSelector(selectPrizeWallDataState);

  useFocusEffect(
    useCallback(() => {
      if (state === 'Finished' && dataState === 'fulfilled') {
        BottomSheet.open({
          namespace: 'prizeWall',
          type: 'PrizeWallFinished',
          titleNS: 'prizeWall',
          titleKey: 'prizeWallFinishedTitle',
          data: {
            onButtonPress: onCheckWinnersPress,
          },
        });
      }
    }, [state, dataState, onCheckWinnersPress]),
  );

  if (!state) {
    return <PrizeWallSkeleton {...rest} />;
  }

  return (
    <Box flex={1} {...rest}>
      {state === 'Pending' ? (
        <PrizeWallOpenInfo margin="space-400" marginBottom="space-0" />
      ) : (
        <PrizeWallWinnersFeed margin="space-400" marginBottom="space-0" />
      )}
      <PrizeWallPrizes
        padding="space-400"
        paddingBottom="space-0"
        onInsufficientBalancePress={onInsufficientBalancePress}
      />
    </Box>
  );
}

export default memo(PrizeWall);
